import Layout from '@/components/Layout'
import Seo from '@/components/Seo'
import { breadcrumbSchema, company, whatsappLink, whatsappMessages } from '@/lib/site-data'
import {MapPin, MessageCircleDashed as MessageCircle} from 'lucide-react'

const crumbs = breadcrumbSchema([
  { name: 'Início', path: '/' },
  { name: 'Contato', path: '/contato' },
])

const contactSchema = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Contato Muita Mídia',
  about: {
    '@type': 'Organization',
    name: company.legalName,
    address: company.address,
  },
}

function Contato() {
  return (
    <Layout>
      <Seo
        title="Contato | Fale com a Muita Mídia pelo WhatsApp"
        description="Entre em contato com a Muita Mídia pelo WhatsApp para comprar uma página do Instagram com segurança. Empresa registrada em Belo Horizonte/MG."
        path="/contato"
        jsonLd={[contactSchema, crumbs]}
      />

      <section className="relative overflow-hidden bg-[#0B0919]">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(139,92,246,0.18),transparent_60%)]" />
        <div className="relative mx-auto max-w-4xl px-6 py-16 text-center sm:py-24">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-xs font-medium text-[#C4B5FD]">
            Contato
          </span>
          <h1 className="mt-6 text-3xl font-bold leading-tight text-white sm:text-4xl">
            Fale com a nossa equipe e comece agora a comprar sua página
          </h1>
          <p className="mt-5 text-base leading-relaxed text-zinc-400 sm:text-lg">
            Todo o nosso atendimento é feito pelo WhatsApp. É por lá que você tira dúvidas, escolhe o
            nicho e a faixa de seguidores, realiza o pagamento e recebe o acesso imediato à sua página.
          </p>
          <a
            href={whatsappLink(whatsappMessages.contactCta)}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-7 py-3.5 text-sm font-semibold text-white shadow-lg shadow-[#25D366]/20 transition-transform hover:scale-105"
          >
            <MessageCircle className="h-5 w-5" fill="white" strokeWidth={0} />
            Iniciar conversa no WhatsApp
          </a>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-3xl px-6 py-16 sm:py-20">
          <div className="rounded-2xl border border-zinc-100 bg-zinc-50 p-8">
            <h2 className="text-lg font-semibold text-zinc-900">Dados da empresa</h2>
            <div className="mt-4 space-y-2 text-sm leading-relaxed text-zinc-600">
              <p><span className="font-medium text-zinc-900">Razão social:</span> {company.legalName}</p>
              <p><span className="font-medium text-zinc-900">CNPJ:</span> {company.cnpj}</p>
              <p className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#7C3AED]" />
                {company.address}
              </p>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-zinc-600">
              Não realizamos atendimento por e-mail ou telefone convencional: para garantir uma resposta rápida
              e um processo de compra seguro, com verificação e transferência assistida, todo o contato acontece
              exclusivamente pelo WhatsApp.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Contato
